import type { InvoiceBillingStatus as InvoiceBillingStatusType } from '@weft/types';
import { INVOICE_BILLING_STATUSES } from '@weft/types';
import { raiseUnreachable } from '@weft/utils';
import React from 'react';
import { getBillingStatusLabel } from '../../../pages/invoices/InvoicesPage/invoices-page-components/InvoiceBillingStatusLabel';
import { Status } from './Status/Status';
import type { StatusType } from './Status/status-types/status-types';

type InvoiceBillingStatusProps = {
  invoiceBillingStatus: InvoiceBillingStatusType;
};

export const InvoiceBillingStatus: React.FC<InvoiceBillingStatusProps> = ({ invoiceBillingStatus }) => {
  return (
    <Status status={getMappedBillingStatus(invoiceBillingStatus)}>
      {getBillingStatusLabel(invoiceBillingStatus)}
    </Status>
  );
};

function getMappedBillingStatus(invoiceBillingStatus: InvoiceBillingStatusType): StatusType {
  switch (invoiceBillingStatus) {
    case INVOICE_BILLING_STATUSES.None:
      return 'INFO';
    case INVOICE_BILLING_STATUSES.Paid:
      return 'SUCCESS';
    case INVOICE_BILLING_STATUSES.Rejected:
      return 'REJECTED';
    case INVOICE_BILLING_STATUSES.Overdue:
      return 'ERROR';
    case INVOICE_BILLING_STATUSES.PendingPayment:
      return 'WARNING';
    case INVOICE_BILLING_STATUSES.OnHold:
      return 'WARNING';
    default:
      return raiseUnreachable(invoiceBillingStatus);
  }
}